import { makeStyles } from '@material-ui/core';

export const useStyle = style =>
	makeStyles(theme => {
		const {
			breakpoints: { down },
			palette: { action, primary },
		} = theme;
		return {
			root: {
				fontFamily: 'Montserrat',
				width: '12vw',
				fontSize: '18px',
				background: action.main,
				color: primary.main,
				textTransform: 'none',
				borderRadius: '0',
				whiteSpace: 'nowrap',
				transition: '200ms all ease-in',
				'&:hover': {
					background: primary.main,
					color: 'white',
				},
				...style,
				[down('sm')]: {
					fontSize: '4vw',
					width: '40vw',
				},
			},
			disabled: {
				opacity: '0.5',
				backgroundColor: `${action.main} !important`,
				fontWeight: 'bold',
			},
		};
	});
